
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboards/[name]",
      function () {
        return require("private-next-pages/dashboards/[name]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboards/[name]"])
      });
    }
  